/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface CloseProps extends React.SVGAttributes<SVGElement> {
size?: string;
}
const Close: React.SFC<CloseProps> = ({size, ...props}) => (
  <svg viewBox="0 0 9 9" fill="currentColor" width={ size || "1em" } height={ size || "1em" } {...props}>
    <path d="M8.207,8.778c-0.139,0-0.27-0.055-0.37-0.154L4.464,5.211L1.163,8.622c-0.1,0.101-0.231,0.156-0.371,0.156	c-0.138,0-0.27-0.056-0.371-0.156C0.323,8.522,0.27,8.391,0.27,8.25s0.054-0.273,0.153-0.373l3.373-3.412L0.422,1.122	c-0.203-0.205-0.203-0.54,0-0.745c0.099-0.1,0.23-0.155,0.37-0.155c0.141,0,0.272,0.055,0.371,0.155l3.373,3.412l3.301-3.412	c0.098-0.1,0.229-0.155,0.37-0.155s0.271,0.055,0.369,0.154C8.676,0.476,8.73,0.608,8.73,0.75S8.676,1.024,8.577,1.123L5.204,4.535	l3.373,3.344C8.781,8.083,8.78,8.417,8.576,8.622C8.478,8.723,8.347,8.778,8.207,8.778z"
    />
  </svg>
);
Close.displayName = 'Close';
export default Close;
/* tslint:enable */
/* eslint-enable */
